import { Anchor } from '@components/Anchor';
import { useAuthProvider } from '@components/AuthProvider';
import { IModalWindow } from '@hooks/useModalWindow';
import { Drawer, Box, List, ListItem, ListItemIcon, IconButton, Avatar, ListItemText, makeStyles } from '@material-ui/core';
import React from 'react';
import { drawerWidth } from './AppConfig';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import AppMenu from './AppMenu';

export type AppDrawerProps = {
    isMenuOpened: boolean
    onDrawerMenuButtonClick: VoidFunction,
    alterarSenhaModal: IModalWindow
}

export function AppDrawer ({ isMenuOpened, alterarSenhaModal, onDrawerMenuButtonClick }: AppDrawerProps) {
    const cls = useStyles();

    const authProvider = useAuthProvider();

    return (
        <Drawer
            className={cls.drawer}
            variant="persistent"
            anchor="left"
            open={isMenuOpened}
            classes={{
                paper: cls.drawerPaper,
            }}
        >
            <div className={cls.drawerHeader}>
                <Box>
                    <List className={cls.drawerAvatarList}>
                        <ListItem>
                            <ListItemIcon>
                                <IconButton onClick={alterarSenhaModal.open}>
                                    <Avatar className={cls.drawerAvatar}>D</Avatar>                                                            
                                </IconButton>
                            </ListItemIcon>
                            <ListItemText 
                                primary={<Anchor onClick={alterarSenhaModal.open}>{authProvider?.state?.user?.displayName || ""}</Anchor>}
                            />
                        </ListItem>
                    </List>
                </Box>

                <IconButton onClick={onDrawerMenuButtonClick}>
                    <ChevronLeftIcon />
                </IconButton>
            </div>

            <div className={cls.drawerContent}>
                <AppMenu 
                    onDrawerItemClick={onDrawerMenuButtonClick}
                />
            </div>
        </Drawer>    
    )
}

const useStyles = makeStyles(theme => ({
    drawer: {
        width: drawerWidth,
        flexShrink: 0,

        '& a': {
            color: theme.palette.text.primary
        },

        '& a:hover': {
            textDecoration: 'none'
        }
    },

    drawerPaper: {
        width: drawerWidth,
    },

    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
        justifyContent: 'space-between',
    },

    drawerAvatarList: {
        '& li': {
            padding: 0
        },

        '& a:hover': {
            textDecoration: 'underline'
        }
    },

    drawerAvatar: {
        color: theme.palette.getContrastText(theme.palette.primary.main),
        backgroundColor: theme.palette.primary.main
    },

    drawerContent: {

    },
}));